export const PALETTE_HEX = {
  bg: '#1a1a2e',
  panel: '#0d0d20',
  deep: '#0a0a1e',
  wallBg: '#2a2a3e',
  wallOuter: '#0d0d1a',
  divider: '#1a1a2e',
  floorLine: '#3a3a5a',
  rockDark: '#0a0a12',
  rockMid: '#15151f',
  rockLight: '#24242f',
  terminal: '#39ff14',
  caution: '#f0c000',
  cautionDark: '#1a1a1a',
  cautionYellow: '#ffcc00',
  skin: '#d4a574',
  overseer: '#4a90d9',
  elder: '#8b6914',
  scout: '#2d8a4e',
  investigator: '#9b59b6',
  scribe: '#607d8b',
  analyst: '#00bcd4',
  tinkerer: '#ff8c42',
  auditor: '#c94e4e',
  designer: '#e6c44d',
  caravaneer: '#d97a3a',
} as const;

const toNumber = (hex: string): number => parseInt(hex.replace('#', ''), 16);

export const PALETTE = Object.fromEntries(
  Object.entries(PALETTE_HEX).map(([k, v]) => [k, toNumber(v)])
) as Record<keyof typeof PALETTE_HEX, number>;
